type IconProps = React.ComponentProps<'svg'>

export function HeartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.41777 1.49049c2.64069-2.25597 6.06371-1.78896 8.32422 0.31543 2.25843-2.10584 5.6446-2.54426 8.31836-0.32227 2.86706 2.38296 3.21265 6.44441 1.0039 9.28711-0.8588 1.1051-2.54797 2.77956-4.18652 4.32617-1.65276 1.56-3.30233 3.03508-4.11621 3.75586-0.08184 0.07248-0.17583 0.15648-0.26367 0.22266-0.09667 0.07278-0.2271 0.15616-0.39747 0.20703-0.23228 0.0693-0.48256 0.0693-0.71484 0-0.17044-0.05087-0.30076-0.13423-0.39746-0.20703-0.08787-0.06619-0.1818-0.15015-0.26367-0.22266-0.81384-0.72074-2.46338-2.19579-4.11621-3.75586-1.63859-1.54663-3.32771-3.22105-4.18653-4.32617-2.21545-2.85123-1.81014-6.88257 0.9961-9.28027z m7.75488 1.88281c-1.77859-2.07882-4.64501-2.56816-6.78125-0.74316-2.20366 1.88286-2.50363 5.00912-0.78516 7.2207 0.77682 0.99952 2.38066 2.59731 4.03125 4.15527 1.63633 1.5445 3.27343 3.00753 4.08204 3.72363 0.00805 0.00713 0.01605 0.01397 0.02343 0.02051 0.00736-0.00651 0.01543-0.01341 0.02344-0.02051 0.80864-0.71613 2.44577-2.17919 4.08203-3.72363 1.65056-1.55794 3.25445-3.15578 4.03125-4.15527 1.72499-2.22006 1.4514-5.36132-0.77734-7.21387-2.18698-1.81755-5.01609-1.33583-6.78906 0.73633-0.14247 0.16656-0.35114 0.26267-0.57032 0.26269-0.21921 0-0.42782-0.09611-0.57031-0.26269z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
